import * as $ from "jquery";
    export class DatePickerDirective implements ng.IDirective {
        public restrict = 'C';
        public require = 'ngModel';
        public link = (scope: any, element: any, attrs: any, ngModelCtrl: any) => {
            $(() => {
                element.datepicker({
                    dateFormat: 'yy-mm-dd',
                    onSelect: (dateText: any) => {

                        ngModelCtrl.$setViewValue(dateText);
                        scope.$apply();
                    }
                });
            });
        }
    }
